import React from 'react';

import { AuctionInformationTooltipContainer } from './AuctionInformationTooltipContainer';
import { AuctionReduceBetModalContainer } from './AuctionReduceBetModalContainer';
import { PublicationDateContainer } from './PublicationDateContainer';
import { VASListContainer } from './VASListContainer';

export function VASContainer() {
  return (
    <>
      <PublicationDateContainer />
      <VASListContainer />
      <AuctionInformationTooltipContainer />
      <AuctionReduceBetModalContainer />
    </>
  );
}
